class ProductMedia extends customElements.get('slider-default') {
  constructor() {
    super();

    this.counter = this.querySelector('.js-counter');
    this.counterTotal = this.counter.querySelector('.js-counter-total');
    this.counterCurrent = this.counter.querySelector('.js-counter-current');
  }

  initSlider() {
    this.sliderOptions.breakpoints = {
      990: {
        allowTouchMove: false,
      },
    };

    super.initSlider();

    this.slidesArray = Array.from(this.slider.slides);

    this.slider.on('transitionStart', (slider) => {
      this.counterCurrent.textContent =
        slider.activeIndex < 10
          ? `0${++slider.activeIndex}`
          : ++slider.activeIndex;
    });
  }
}

customElements.define('product-media', ProductMedia);
